<template>
	<section :class="[
		'block-wrapper', 
		componentClass, 
		{
			ready: ready
		}
	]">
		<div class="row">
			<div class="columns small-12 xlarge-10 xlarge-offset-1">
				<div class="covid-content-wrapper">
					<div :class="['media-column']">
						<div class="media-wrapper">
							<div class="square light-yellow">
								<summer-chill />
							</div>
							<div class="square cover-image">
								<img :src="require('./covid-page/images/girl-with-mask.jpg')" class="girl" />
							</div>
							<div class="square cover-image">
								<img :src="require('./covid-page/images/map-square.jpg')" class="map" />
							</div>
							<div class="square dark-green">
								<img :src="require('./covid-page/images/yellow-heart.svg')" class="heart" />
							</div>
						</div>
					</div>
					<div :class="['text-column']">
						<wysiwyg-content ref="textWrapper" 
							:data="data.wysiwyg_content" 
							:columns="2"></wysiwyg-content>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>


<script>
import BaseDynamicBlock from './BaseDynamicBlock'
import WysiwygContent from 'RuterSharedBlocks/wysiwyg/Content'
import SummerChill from './covid-page/SummerChill'

export default {
	extends: BaseDynamicBlock,
	data() {
		return {
			defaultColorMode: 'light',
			componentClass: 'covid-block',
		}
	},
	components: {
		WysiwygContent,
		SummerChill
	}
}
</script>

<style lang="scss">
@import "@/styles/scss/component/_covid-block";
</style>